import store from "@/redux/store";

import React, { useState } from "react";
import { Link, useParams, useNavigate, useLocation } from "react-router-dom";

//import {showLoader,hideLoader} from "actions/types";
import { connect } from "react-redux";
import { Login } from "@/views/authorisation/Login";
import { Resetpassword } from "@/views/authorisation/ResetPassword";
import ResetPasswordSet from "@/views/authorisation/ResetPassword2";
import Registration from "@/views/authorisation/Registration"; 
import { loginUser, resetpassword, resetpassword2 } from '@/reducers/Authorisation'
import CookieHelper from "helpers/cookie";


export const RESETPASSWORD = "RESET_PASSWORD";
export const RECOVERPASSWORD = "RECOVER_PASSWORD";
export const REGISTRATION = "REGISTRATION";

    
class LoginController extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, isLoaded: false, secret: null };
  }

    
    onLoginEvent = async (data) => {
        const { dispatch } = this.props;

     try {
        await dispatch(loginUser(data)); 
      } catch (err) {
        console.error('Failed to save the post: ', err)
      } finally {

      }
    };

    checkHash = async (data) => {
        const { dispatch } = this.props;

     try {
        await dispatch(loginUser(data)).then((retData) => {
            if(!retData.error) {
                //this.props.navigate("/", {"replace": true});
            } 
            });
      } catch (err) {
        console.error('Failed to save the post: ', err) 
      } finally {

      }
    };

    onResetpasswordEvent = async (data) => {
        const { dispatch } = this.props;

     try {
        await dispatch(resetpassword(data)).then((action) => {
            if(action['payload'] && action["payload"]["data"] && action["payload"]["data"]["message"]
                && action["payload"]["data"]["message"]["redirect"] && action["payload"]["data"]["message"]["redirect"] != ""
            ) {
                this.props.navigate("/"+action["payload"]["data"]["message"]["redirect"], {"replace": true});
                }
        });
      } catch (err) {
        console.error('Failed to reset password: ', err)
      } finally {

      }
    };

    onResetpasswordSetEvent = async (data) => {
        const { dispatch } = this.props;
        const {hashKey} = this.props;

     try {
         let dataObj = {data : data, hashKey: hashKey};
        await dispatch(resetpassword2(dataObj)).then((retData) => {
            if(!retData.error) {
                this.props.navigate("/login");
            } 
            });
      } catch (err) {
        console.error('Failed to reset password: ', err)
      } finally {

      }
    };


  
  render() {
      const {view} = this.props;
      const {Authreducer} = this.props;
      //const {data} = Authreducer.error.data;
      let component = (<Login {...this.props} onLoginEvent={this.onLoginEvent} key="RP0"/>);
      switch(view) {
          case RESETPASSWORD:
              component = (<Resetpassword {...this.props} onResetpasswordEvent={this.onResetpasswordEvent} key="RP1"/>);
              break;
          case RECOVERPASSWORD:
              component = (<ResetPasswordSet {...this.props} onResetpasswordSetEvent={this.onResetpasswordSetEvent} key="RP2"/>);
              break;
          case REGISTRATION:
              component = (<Registration {...this.props} onResetpasswordSetEvent={this.onResetpasswordSetEvent} key="RP3"/>);
              break;
              
      } 
    return (
      [component]
    );
  }
}

const LoginControllerInit = (props) => {
    
  return (
    <LoginController
      {...props}
    />
  );
};

function mapStateToProps(state) {
    const {AuthReducer} = state;
    const {hash} = useParams();
    const navigate = useNavigate();
  return {
      hashKey: hash,
      AuthReducer,
      state: {...AuthReducer},
      navigate: navigate
  };
}


export default connect(mapStateToProps)(LoginControllerInit);
